import { render, staticRenderFns } from "./TeacherTitlings.vue?vue&type=template&id=2a5b6bcd"
import script from "./TeacherTitlings.vue?vue&type=script&lang=js"
export * from "./TeacherTitlings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports